import React from 'react'

const Pagination = ({
  totalCount,
  currentPage,
  pageSize,
  onNext,
  onPrevious
}) => {
  const firstPageIndex = (currentPage - 1) * pageSize + 1
  const lastIndex = firstPageIndex + pageSize - 1
  const totalPages = Math.ceil(totalCount / pageSize)
  return (
    <div>
      <p>
        Displaying {firstPageIndex}-
        {lastIndex < totalCount ? lastIndex : totalCount} of {totalCount}
      </p>
      {currentPage !== 1 && (
        <button
          className="button -dark -large mr-32 mb-32"
          onClick={onPrevious}
        >
          Previous {pageSize}
        </button>
      )}
      {totalPages !== currentPage && (
        <button
          className="button -dark -large mb-32"
          onClick={onNext}
        >
          Next {pageSize}
        </button>
      )}
    </div>
  )
}

export default Pagination
